import image from 'shared/assets/images/integrationsSliders/front/front.png'
import { LINK_FRONT_INTEGRATION_GUIDE } from 'shared/constants/links'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const front: IntegrationDetailsData = {
  subheadline: 'Enhance your shared inbox with comprehensive messaging data.',
  overview:
    'Connect Salesmsg with Front to streamline your workflow and keep your shared inbox up to date. When you engage with contacts through Salesmsg, relevant information flows to Front, ensuring your records stay current without manual data entry.',
  keyBenefits: [
    'Quick setup through the Salesmsg App Marketplace',
    'Reduce manual data entry and improve workflow efficiency',
    'Seamless integration between your messaging and shared inbox workflows',
  ],
  images: [image],
  docs: LINK_FRONT_INTEGRATION_GUIDE,
}
